const channel = new BroadcastChannel('auth_channel');

const AUTH_STORAGE_KEYS = [
  'authenticationToken', 'email', 'name',
  'isStudent', 'isGrader', 'isReviewer', 'isAdmin', 'isExamAdmin', 'isTeacher'
];

function clearAuthFromSessionStorage() {
  AUTH_STORAGE_KEYS.forEach(key => sessionStorage.removeItem(key));
}

export const setupAuthChannel = (onTokenReceived, onChannelReady, onLogout) => {

    channel.onmessage = (event) => {
    const { type, token, userData } = event.data;

    if (type === 'LOGOUT') {
      clearAuthFromSessionStorage();
      if (onLogout) onLogout();
      return;
    }

    if (type === 'REQUEST_TOKEN') {
      const existingToken = sessionStorage.getItem('authenticationToken');
      if (existingToken) {
        // Enviar usuario y token con sessionStorage al channel
        const userData = {
          authenticationToken: existingToken,
          email: sessionStorage.getItem('email'),
          name: sessionStorage.getItem('name'),
          isStudent: sessionStorage.getItem('isStudent'),
          isGrader: sessionStorage.getItem('isGrader'),
          isReviewer: sessionStorage.getItem('isReviewer'),
          isAdmin: sessionStorage.getItem('isAdmin'),
          isExamAdmin: sessionStorage.getItem('isExamAdmin'),
          isTeacher: sessionStorage.getItem('isTeacher'),
        };
        channel.postMessage({ type: 'SEND_TOKEN', token: existingToken, userData });
      }
    }

    if (type === 'SEND_TOKEN' && token && userData) {
      // Guardar usuario y token con sessionStorage
      sessionStorage.setItem('authenticationToken', token);
      sessionStorage.setItem('email', userData.email);
      sessionStorage.setItem('name', userData.name);
      sessionStorage.setItem('isStudent', userData.isStudent);
      sessionStorage.setItem('isGrader', userData.isGrader);
      sessionStorage.setItem('isReviewer', userData.isReviewer);
      sessionStorage.setItem('isAdmin', userData.isAdmin);
      sessionStorage.setItem('isExamAdmin', userData.isExamAdmin);
      sessionStorage.setItem('isTeacher', userData.isTeacher);
      
      onTokenReceived({token, userData});
    }
  };

  if (!sessionStorage.getItem('authenticationToken')) {
    channel.postMessage({ type: 'REQUEST_TOKEN' });
  }

  // Delay para que el BroadcastChannel establezca la comunicación entre pestañas
  if (onChannelReady) {
    setTimeout(onChannelReady, 10);
  }
};

export const broadcastLogout = () => {
  channel.postMessage({ type: 'LOGOUT' });
};

export const closeAuthChannel = () => {
  channel.close();
}; 